<template>
  <div class="contentNav">
      <div @click="gotoRoute('ClassScheduleCard')">
          <p class="title">参与的课程</p>
          <p class="num">{{info.joincount ? info.joincount : '--'}}</p>
          <div style="width: 1px"></div>
      </div>
      <div @click="gotoRoute('MyOrder', 2)">
          <p class="title">购买的报告</p>
          <p class="num">{{info.buycount ? info.buycount : '--'}}</p>
          <div style="width: 1px"></div>
      </div>
      <div @click="gotoRoute('MyConcern')">
          <p class="title">我的关注</p>
          <p class="num">{{info.followcount ? info.followcount : '--'}}</p>
          <div style="width: 1px"></div>
      </div>
      <div @click="gotoRoute('MyCollection')" class="none">
          <p class="title">我的收藏</p>
          <p class="num">{{info.favoritecount ? info.favoritecount : '--'}}</p>
      </div>
  </div>
</template>

<script>
import {getUserStatisticsInfo} from 'api/personalCenterApi'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'contentNav',
  data () {
    return {
        info: {},   // 统计数据
    }
  },
  mounted () {
      console.log(this.$route.name)
      if (this.$route.name !== 'StartTopic') {
        this.getUserStatisticsInfos()
      }
  },
  methods: {
      getUserStatisticsInfos() {
          this.setLoading(true)
        getUserStatisticsInfo({
            data: {},
            success: data => {
                this.setLoading(false)
                this.info = data.data
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      },
      gotoRoute(name, status) {
          this.$router.push({name: name, query: {kmctype: status}})
      },
      ...mapActions(['setLoading']),
      ...mapGetters(['user']),
  },
  filters: {
  },
  watch: {
      isLoginStaus() {
          // 登录状态发生变化 刷新页面
          window.location.reload()

      },
  },
  computed: {
       isLoginStaus() {
          return this.user().isLogin
      }
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.contentNav {
    margin-bottom: 13px;
    height: 103px;
    background: #fff;

    div {
        float: left;
        position: relative;
        padding: 20px;
        width: calc(100% / 4);
        text-align: center;
        box-sizing: border-box;

        .title {
            font-size: 14px;
            color: #333333;
            cursor: pointer;
        }
        .num {
            margin-top: 20px;
            font-size: 24px;
            color: #409EFF;
            cursor: pointer;
        }
        div {
            position: absolute;
            margin: auto;
            padding: 0;
            top: 0;
            bottom: 0;
            right: 0;
            // width: 0.01rem;
            height:60px;
            background: #E5E5E5;
        }
       
        // &:last-child::after {
        //     content: '';
        //     height: 0;
        // }
        
    }
}
</style>